var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"top_all"},[_c('img',{attrs:{"src":require("../assets/img/index/ico.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }